import { Injectable } from '@angular/core';
import { LanguageService } from '../services/language.service';
import { NgbDateParserFormatter, NgbDateStruct, NgbDate } from '@ng-bootstrap/ng-bootstrap';

@Injectable()
export class CustomNgbDateParserFormatter extends NgbDateParserFormatter {

    /**
     * convert NgbDateStruct to Date
     *
     * @static
     * @param {NgbDateStruct} ngbDate
     * @returns {Date}
     * @memberof CustomNgbDateParserFormatter
     */
    static toDate(ngbDate: NgbDateStruct): Date {
        return new Date(ngbDate.year, ngbDate.month - 1, ngbDate.day, 12, 0, 0);
    }

    /**
     * convert Date to NgbDateStruct
     *
     * @static
     * @param {Date} date
     * @returns {NgbDateStruct}
     * @memberof CustomNgbDateParserFormatter
     */
    static toNgbDate(date: Date): NgbDateStruct {
        return new NgbDate(date.getFullYear(), date.getMonth() + 1, date.getDate());
    }

    /**
     * Creates an instance of CustomNgbDateParserFormatter.
     * @param {LanguageService} language
     * @memberof CustomNgbDateParserFormatter
     */
    constructor(private language: LanguageService) {
        super();
    }

    /**
     * custom implementation of parse
     *
     * @param {string} value
     * @returns {NgbDateStruct}
     * @memberof CustomNgbDateParserFormatter
     */
    parse(value: string): NgbDateStruct {
        const date = this.language.parseDate(value);
        return CustomNgbDateParserFormatter.toNgbDate(date);
    }

    /**
     * custom implementation of format
     *
     * @param {NgbDateStruct} date
     * @returns {string}
     * @memberof CustomNgbDateParserFormatter
     */
    format(date: NgbDateStruct): string {
        return date ? this.language.formatDate(CustomNgbDateParserFormatter.toDate(date)) : '';
    }

}
